import styled from '@emotion/styled'
import { Paragraph } from 'components/patterns'
import { stylesIf } from 'utils/styles'

export const RemovedItemBorder = styled.div(
  ({ removed, theme }) => `
  position: relative;
  width: 50px;
  height: 100px;
  border-radius: 3px;
  border-size: 3px;
  border-style: solid;
  ${stylesIf(
    removed,
    `
    border-color: ${theme.sAndGRemoveComponentOutline};
  `
  )}
`
)

export const PartPositioner = styled.div((props) => {
  const {
    isBeingDragged,
    position: { top, left, zIndex } = {},
    detailView,
    dimensions: { width, height } = {},
  } = props

  return `
    position: absolute;
    top: ${top}px;
    left: ${left}px;
    z-index: ${zIndex};
    
    ${stylesIf(
      !detailView && width && height,
      `width: ${width}px; height: ${height}px;`
    )}
    ${stylesIf(
      !detailView && width === undefined && height === undefined,
      'height: auto;'
    )}

    svg {
      position: absolute;
    }

    ${stylesIf(
      isBeingDragged,
      `
      z-index: 100;
    `
    )}
  `
})

export const StyledPart = styled.div((props) => {
  const { dimensions = 1 } = props

  const { width, height } = dimensions
  return `
    width: ${width}px;
    height: ${height}px;
    display: block;
    position: relative;
  `
})
StyledPart.defaultProps = { className: 'styled-part' }

export const Pill = styled.div((props) => {
  const {
    removed,
    theme: { sAndGPillMoved, sAndGPillRemoved },
  } = props

  return `
    display: inline;
    margin: 0 auto;
    top: -2px;
    width: 48px;
    height: 16px;
    background-color: ${removed ? sAndGPillRemoved : sAndGPillMoved};
    font-size: 8px;
    color: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  `
})

export const TooltipPositioner = styled.div((props) => {
  const { showPartNumbers } = props
  return `
    ${stylesIf(showPartNumbers, `position: relative;`)}
  `
})
TooltipPositioner.defaultProps = { className: 'tooltip-positioner' }

export const TooltipTypeRow = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`

export const TooltipCustomCapLabel = styled.span`
  color: var(--White-White-Primary, #fff);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  margin-left: 8px;
`

export const TooltipIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const StyledTooltipParagraph = styled(Paragraph)((props) => {
  const { hasIcon } = props
  const marginValue = hasIcon ? '8' : '-4'
  return `
  display: inline-block;
  vertical-align: super;
  margin-left: ${marginValue}px;
`
})
